import http from '@/utils/http.js' // 引入封装的request.js文件
import common from '@/config/common.js'

//查询是否报班
export function queryClazzReportState(data) {
    return http.request({
        url: common.url + '/papi/user_clazz/queryClazzReportState',
        method: 'get',
		params:data
    })
}

//查询用户的班级信息详情
export function queryClazzUserInfo() {
    return http.request({
        url: common.url + '/papi/user_clazz/queryClazzUserInfo',
        method: 'get',
    })
}

//查询用户的班级信息详情
export function queryUserSchoolHours(data) {
    return http.request({
        url: common.url + '/papi/clazz/queryUserSchoolHours',
        method: 'get',
		params:data
    })
}
